export enum HubspotChatStatusEnum {
  Loading = 'loading',
  Loaded = 'loaded',
  Blocked = 'blocked'
}